export default "__VITE_ASSET__b2815270__"